import React, { useContext, useEffect, useState } from 'react';
import Modal from '../../../UI/Modal/Modal'
import cl from './Edit.module.css'  
import Pen from "../../../../assets/Icon/Pen";   
import { AppContext } from '../../../../providers/appProvider';
import { useTranslation } from 'react-i18next';

const RoleEditModal = ({ roleService, defaultRole }) => {
    const {t} = useTranslation();
    
    const roleResetData = {
        id: 0,
        name: "",
        description: "", 
        permission_ids:  []

    }

    const initEditRole = (role) => {
        return {
            id: role.id,
            name: role.name,
            description: role.description, 
            permission_ids: role.permission_ids
        }
    }

    const [newRole, setNewRole] = useState(roleResetData)
    const [isFirstValidated, setIsFirstValidated] = useState(false)
    const [validates, setValidates] = useState({})


    const { appState, app } = useContext(AppContext);
    const permissions = appState.all_permissions;

    const validateRole = (role) => {
        const messages = {};
    
        if (role.name.length < 2) {
            messages.firstname = { message: 'მიუთითეთ სახელი', isValid: false };
        }
  
        const isValid = Object.keys(messages).length === 0;
        setValidates(messages)
        return isValid;  
      };

    const reValidate = () => {
        const isValidate = validateRole(newRole)
        
    }

    useEffect(() => {
        if (isFirstValidated === true) {
            const isValidate = validateRole(newRole)
        }
      }, [newRole, isFirstValidated]);

      useEffect(() => {
        const editedCar = initEditRole(defaultRole)
         setNewRole(editedCar)
    }, [defaultRole]);

    const [isModalOpen, setIsModalOpen] = useState(false);
 
    const saveHandle = () => {
         
        const isValidate = validateRole(newRole)

        if (isValidate === true) {
            roleService.update(newRole)
            setIsModalOpen(false)
        } else {
            setIsFirstValidated(true) 
        } 
         
    };

    const handleClientChange = async (event) => {
        let val = event.target.value;
        setNewRole(prevClient => ({
            ...prevClient,
            [event.target.name]: val
        })); 
    };

    const openAdd = () => {
        setValidates({})
        setIsModalOpen(true) 
        setIsFirstValidated(false) 
    }

    const handleItemClick = (itemId) => {
        if (newRole.permission_ids.includes(itemId)) {
            setNewRole(prevClient => ({
                ...prevClient,
                permission_ids: newRole.permission_ids.filter(id => id !== itemId)
            }));  
        } else {
            setNewRole(prevClient => ({
                ...prevClient,
                permission_ids: [...newRole.permission_ids, itemId]
            })); 
        }
      };
 
    return (
        <div>

            <span className={ cl.editBtn } onClick={() => openAdd()} >
            <Pen /> {t('Update')}
            </span>

            <Modal size="small" isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
 
                <div className={cl.modalHead} >
                    <h3>
                    <span className={cl.iconHead} > <Pen /></span> {t('Update')}
                    </h3>
                </div>
   
               
                <div className={cl.groupInput}> 
                            <input type="textS"
                                className={validates && validates.name ? cl.input + ' ' + cl.errorInput : cl.input}
                                id="name" name="name" value={newRole.name} onChange={handleClientChange} autoComplete="off" />
                            <label htmlFor="name">{t('Name')}</label>
                    </div>

                    <div className={cl.groupInput}> 
                            <input type="textS"
                                className={validates && validates.description ? cl.input + ' ' + cl.errorInput : cl.input}
                                 name="description" id="description" value={newRole.description} onChange={handleClientChange} autoComplete="off" />
                            <label htmlFor="description">{t('Description')}</label>
                    </div> 
                    
                     
                    <div className={ cl.rolesSelect }  >
                        <label>{t('Permissions')}</label>
                        <ul style={{ maxHeight: '400px', overflowY: 'auto',   }}>
                            {permissions.map((item) => (
                                <li
                                    key={item.id}
                                    onClick={() => handleItemClick(item.id)}
                                    className={newRole.permission_ids.includes(item.id) ? cl.selected : ' '}
                                >
                                    {item.description}
                                </li>
                            ))} 
                        </ul> 
                    </div> 

  
                <span onClick={saveHandle} className={cl.btnPrimary}>{t('Save')}</span> 
            </Modal>
        </div>
    );
};

export default RoleEditModal;